<script>
	import { onMount } from 'svelte';

	// -
	import Header from './Header.svelte';
	import Legal from './Legal.svelte';
	import CookiesFooter from './CookiesFooter.svelte';

	// - SVG's
	import logo from './svg/logo.svg';
	import curva from './svg/curva.svg';
	import phoneIcon from './svg/phone_button.svg';
	import logoRide from './svg/logo-ride.svg';
	import logoBadiu from './svg/logo-badiu.svg';
	import logoPedraiLlosa from './svg/logo-pedra-i-llosa.svg';
	
	import { win, loaded, scrollY, totalLayers, lang, langs, phone, overPhone, showingLegal } from "./store.js";

	function showLegal(e){
		showingLegal.set(true);
	}
	
	// -
	function changeLang(e){
		lang.set(e.target.id);
	}

	// -
	function overphone(e){
		overPhone.set(true);
	};
	function outphone(e){
		overPhone.set(null);
	};

	let yScroll;
	function onscroll(_y) {
		const yscroll = _y < 0 ? 0 : _y;
		scrollY.set(yscroll);
		return yscroll;
	}
	$: ydispatcher = onscroll(yScroll);

	// - Resize
	function resizeWindow() {
		let _win = false;
        win.subscribe( value => { _win = value; } );
		// -
		_win.width = window.innerWidth; 
		_win.height = window.innerHeight;
		win.set(_win);
	}
	
	// - Init
	onMount(function(){
		resizeWindow();

		// - Preloading?
        setTimeout( function(){
			loaded.set(true);
		}, 1000 );
		
		setTimeout( function(){
			resizeWindow(); 
        }, 4000 );
	});
</script>



<svelte:head>
	<!--<link href="https://fonts.googleapis.com/css2?family=Barlow&family=Bebas+Neue&text=rescuat{phone}{langs.join('')}&display=swap" rel="stylesheet" />-->
	<link href="https://fonts.googleapis.com/css2?family=Barlow&family=Bebas+Neue&display=swap" rel="stylesheet" />

</svelte:head>

<svelte:window on:resize='{resizeWindow}' bind:scrollY={yScroll} />

<template lang="pug">
	.main-logo {@html logo}

	nav.lang
		+each( 'langs as _lang (_lang)' )
			.link( id="{_lang}" on:click="{changeLang}" class:active="{_lang === $lang}" ) {_lang}

	CookiesFooter
		
	main( class:loaded="{$loaded}" )
		Header
		#vignette-top( style="opacity:{0.3 + ($scrollY * 0.01)}" )

		.body( style="transform: translateY({-$scrollY * (7 / totalLayers) * 1}px)" )
			.curva {@html curva}

			#phone-container
				a.phone( href="tel:+34 {phone}" on:mouseenter="{overphone}" on:mouseleave="{outphone}")
					.text {phone}
					.icon {@html phoneIcon}

			.content.max-width
				+if( '$lang === "cat"' )
					//h2 Missions de extracció de vehicles de muntanya
					h1 Rescat de vehicles a la Cerdanya
					p El teu vehícle necessita un rescat en plena muntanya?
					p Proporcionem missions d’extracció de vehícles  a qualsevol punt entre la serra del Cadí i la frontera amb França.
					p Amb la nostra flota de vehícles especials ens adaptarem a les necessitats del teu rescat.
					p Perquè totes les males decisions poden acabar amb una genial història, deixan’s ajudar-te amb el final.
					
					+elseif( '$lang === "esp"' )
						//h2 Misiones de extraccion de vehiculos de montaña
						h1 Rescate de vehículos en la Cerdanya
						p ¿Tu vehículo necesita un rescate en plena montaña?
						p Efectuamos misiones de extracción de vehículos  a cualquier punto entre la sierra del Cadí y la frontera con Francia.
						p Con nuestra flota de vehículos especiales nos adaptaremos a las necesidades de tu rescate.
						p Porque todas las malas decisiones pueden acabar con una genial historia, déjanos ayudarte con el final.

						+else()
							//h2 Offroad vehicle extract missions
							h1 Rescue of vehicles in Cerdanya
							p Does your vehicle need a rescue in the middle of the mountain?
							p We provide vehicle extraction missions to any point between the Cadi Mountains and the French border.
							p With our fleet of special vehicles we will adapt to the needs of your rescue.
							p Because all bad decisions can end up with a great story, let us help you with the ending.

			.partners
				+if( '$lang === "cat"' )
					h2 Els nostres col·laboradors
					+elseif( '$lang === "esp"' )
						h2 Nuestros colaboradores
						+else()
							h2 Our partners
				
				.logos
					a.logo#ride(href="https://www.theride.es") {@html logoRide}
					a.logo#badiu(href="http://www.elbadiu.cat") {@html logoBadiu}
					a.logo#pedraillosa(href="https://www.pedraillosa.com") {@html logoPedraiLlosa}

			footer(style="transform: translateY({$scrollY-60}px);" )
				.link( on:click="{showLegal}" )
					+if( '$lang === "cat"' )
						p Avís legal - Política de privacitat

						+elseif( '$lang === "esp"' )
							p Aviso legal - Política de privacidad

							+else()
								p Legal Notice - Privacy Policy

	Legal
</template>








<style global lang="stylus">
	@require "./stylus/reset"
	@require "./stylus/globals"
	// -
	::selection
		color $n
		background $orange
	html
		overflow hidden
		width 100vw
		height 100vh
		overflow-y auto

	body
		margin 0
		padding 0
		background-color $n
		fNormal()
		color $b
		line-height 1.2em
		font-size 22px

		@media $Md
			font-size 18px

		.max-width
			width 100%
			max-width 700px
			margin 0 auto

		.link
			cursor pointer
			pointer-events auto

		svg
			width 100%
			height 100%

		.main-logo
			position fixed
			z-index 202

			svg
				path
					&.orange
						fill $orange
					&.gris
						fill $gris

			top 20px
			left 20px
			width 180px

			@media $Md
				top 18px
				left 18px
				width 18vw

			@media $Sm
				top 10px
				left 10px
				width 20vw

		nav.lang
			position fixed
			top 12px
			z-index 200
			fBig()

			right 30px
			@media $Md
				right 20px

			.link
				position relative
				color $orange
				text-transform uppercase
				text-decoration none
				font-size 25px
				margin-left 8px
				display inline-block
				&:after
					content ''
					position absolute
					left 0
					bottom -0.15em
					width 100%
					height 0.15em
					background-color $orange

					transform scaleX(0)
					will-change transform
					transition transform .3s ease-out

				&.active
					&:after
						transform scaleX(1)


		main
			text-align center
			display inline-block
			width 100%
			overflow hidden
			opacity 0
			will-change opacity
			transition opacity 1s

			&.loaded
				opacity 1

			#vignette-top
				position fixed
				z-index 90
				width 100%
				height 110px
				top 0
				left 0
				background linear-gradient(180deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.85) 30%, rgba(0,0,0,0.0) 100%)

				will-change opacity

			.body
				position relative
				display block
				width 100%
				background-color $n
				
				margin-top 2vh
				padding-bottom 2vh

				@media $Sm
					margin-top -14vh

				h2,h1
					text-transform uppercase
					color $orange
					display block
					width 100%
					fBig()
					margin-bottom 0.5em

					font-size 65px
					@media $Md
						font-size 35px

					@media $Sm
						font-size 25px

				.curva
					position absolute
					left 0
					width 100%
					top -7vw

					svg
						path
							fill $n
			
				#phone-container
					position relative
					display block

					display flex
					flex-flow column
					align-items center

					margin-top -7vh
					@media $Md
						margin-top 6vh

					@media $Sm
						margin-top 6vh

					a.phone
						text-decoration none
						text-shadow 0px 10px 8px rgba(0, 0, 0, 0.25)

						will-change transform
						transition transform .3s cubic-bezier(0.49, 0.13, 0.21, 0.97)
						
						display flex
						flex-flow column
						align-items center

						margin-top -14vh
						@media $Md
							margin-top -4vh

						@media $Sm
							margin-top -4vh
						
						.text
							display inline-block
							fBig()
							color $grisClar
							font-size 12vw
							@media $Md
								font-size 12vw

							@media $Sm
								font-size 15vw

						.icon
							margin-top -1.4%
							display inline-block
							transform scale(0.8)

							will-change transform
							transition transform .3s cubic-bezier(0.49, 0.13, 0.21, 0.97)

							width 7vw
							height 7vw

							@media $Md
								width 10vw

							@media $Sm
								width 14vw
								height 12vw

							svg
								circle
									fill $orange
								path
									fill $n

						&:hover
							transform translateY(-3px)
							.icon
								transform scale(1)

				.content
					color $grisClar
					margin-top 1.7em
					padding 0 30px
					opacity 0.8

					p
						margin-bottom 1.5em

				.partners
					display block
					text-align center
					width 100%
					max-width 730px

					margin 24vh auto -24vh auto

					.logos
						display flex
						justify-content space-around
						width 100%
						flex-flow row

						margin-top 9vh
						margin-bottom -9vh

						@media $Sm
							margin-top 12vh

						a.logo
							width 22%
							svg
								path
									will-change fill
									transition fill .2s ease-out
									fill $gris

							&#pedraillosa
								width 17%

							&:hover
								svg path
									fill $b

						@media $Md
							flex-flow column
							align-items center

							a.logo
								margin-bottom 40px
								width 40%

								&#pedraillosa
									width 37%
						
						@media $Sm
							a.logo
								margin-bottom 40px


				footer
					position relative
					width 100%
					text-align center
					font-size 15px

					.link
						color $orange
						text-decoration none

						&:hover
							text-decoration underline

</style>